import { render, staticRenderFns } from "./EventTableManagementPage.vue?vue&type=template&id=79f16785"
import script from "./EventTableManagementPage.vue?vue&type=script&lang=js"
export * from "./EventTableManagementPage.vue?vue&type=script&lang=js"
import style0 from "./EventTableManagementPage.vue?vue&type=style&index=0&id=79f16785&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports